interface Occupation {
  value: string
  label: string
}

const Occupations: Occupation[] = [
  { value: "CONTRACTOR", label: "Contratista" },
  { value: "PRIVATE_EMPLOYEE", label: "Empleado privado" },
  { value: "PUBLIC_EMPLOYEE", label: "Empleado público" },
  { value: "SELF_EMPLOYED", label: "Trabajo por cuenta propia" },
  { value: "STUDENT", label: "Estudiante" },
  { value: "FINANCE_SECTOR", label: "Sector financiero" },
  { value: "RETIRED", label: "Jubilado" },
  { value: "PROFESSIONAL", label: "Profesional" },
  { value: "HOMEMAKER", label: "Ama de casa" },
  { value: "PENSIONER", label: "Pensionado" },
  { value: "PRIMARY_SECTOR", label: "Sector primario" },
  { value: "SECONDARY_SECTOR", label: "Sector secundario" },
  { value: "TERTIARY_SECTOR", label: "Sector terciario" },
  { value: "UNEMPLOYED", label: "Desempleado" },
  { value: "ENTREPRENEUR", label: "Empresario" },
  { value: "MERCHANT", label: "Comerciante" },
  { value: "OTHER", label: "Otro" },
]

export default Occupations
